<template>
  <div class="busi2-page busi-detail">
    <section class="banner">
      <h1>智能配网服务</h1>
      <p>
        在智能配网领域，多年来公司积累了丰富的项目设计和实施经验，为客户提供从策划、立项到设计、建设再到送电、试运行的“一站式”EPC（总承包）服务。
        <a href="https://www.wjx.cn/vm/t9gPiBR.aspx#" target="_blank">立即咨询</a>
      </p>
    </section>
    <h2 class="center">响应场景</h2>
    <p class="center">公司承接110kV及以下的智能化变电站、配电网、智能微网、智能充电站、智能用电小区等业务。</p>
    <ul class="scale-img ctn">
      <li :class="{c: curImg === 0}" @mouseenter="curImg = 0">
        <i></i>
        <h3>智能化变电站</h3>
        <p>由电源点为客户供电的电缆、线路、通信工程，将电源通过配电设备进行转供电至用电侧</p>
      </li>
      <li :class="{c: curImg === 1}" @mouseenter="curImg = 1">
        <i></i>
        <h3>配电网</h3>
        <p>由电源点为客户供电的电缆、线路、通信工程，将电源通过配电设备进行转供电至用电侧</p>
      </li>
      <li :class="{c: curImg === 2}" @mouseenter="curImg = 2">
        <i></i>
        <h3>智能微网</h3>
        <p>由电源点为客户供电的电缆、线路、通信工程，将电源通过配电设备进行转供电至用电侧</p>
      </li>
      <li :class="{c: curImg === 3}" @mouseenter="curImg = 3">
        <i></i>
        <h3>智能充电站</h3>
        <p>由电源点为客户供电的电缆、线路、通信工程，将电源通过配电设备进行转供电至用电侧</p>
      </li>
      <li :class="{c: curImg === 4}" @mouseenter="curImg = 4">
        <i></i>
        <h3>智能用电小区</h3>
        <p>由电源点为客户供电的电缆、线路、通信工程，将电源通过配电设备进行转供电至用电侧</p>
      </li>
    </ul>
    <h2>智能化升级</h2>
    <p>公司为客户进行外电源、小区配电室、客户配电室、电气改造、电力基建等建设实施服务及智能化升级改造服务。</p>
    <ul class="icon ctn">
      <li>
        <i></i>
        <h3>外电源</h3>
        <p>由电源点为客户供电的电缆、线路、通信工程，将电源通过配电设备进行转供电至用电侧</p>
      </li>
      <li>
        <i></i>
        <h3>小区配电室</h3>
        <p>建成后为居民生活设施供电，将高压电源变为380v/220v电压的变配电工程</p>
      </li>
      <li>
        <i></i>
        <h3>客户配电室</h3>
        <p>建成后为非居民生活设施供电，将高压电源变为380V/220v电压的变配电工程</p>
      </li>
      <li>
        <i></i>
        <h3>电气改造</h3>
        <p>根据现有环境、用电需求和用电状况等因素对供用电设备、供用电线路和相关设备装置更换、变更、调整等的工程</p>
      </li>
      <li>
        <i></i>
        <h3>电力基建</h3>
        <p>为客户提供电力基建服务，包括了高压线路迁改、电力市政、综合市政等工程实施</p>
      </li>
    </ul>
    <h2>一站式服务</h2>
    <p>客户在电能项目立项、手续办理、建设实施及后续运行送电过程中所面临的全部问题，公司都可依据客户需求结合实际情况给出最优解决方案。</p>
    <div class="flow ctn">
      <img src="@/assets/b2-8.png"/>
      <ul>
        <li>策划</li>
        <li>立项</li>
        <li>手续</li>
        <li>设计</li>
        <li>设备</li>
        <li>建设</li>
        <li>送电</li>
        <li>试运行</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  data() {
    return {
      curImg: 0
    }
  }
}
</script>
